import { UserModalLocale } from "..";

const locale: UserModalLocale = {
  principal_name: 'login name',
  display_name: 'display name',
  email: 'email',
  mobile: 'mobile',
  status: 'status',
  created_at: 'create time',
};

export default locale
